// AuditLogModal.js - Granskningslogg för journaler (admin only)
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { getAuditLog } from '../api/journalApi';
import './AuditLogModal.css';

const AuditLogModal = ({ entryId, patientName, onClose }) => {
  const [auditLog, setAuditLog] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAuditLog();
  }, [entryId]);

  const loadAuditLog = async () => {
    try {
      setLoading(true);
      const data = await getAuditLog(entryId);
      setAuditLog(data.audit_log || []);
    } catch (error) {
      console.error('Error loading audit log:', error);
      if (error.response?.status === 403) {
        toast.error('Du har inte behörighet att se granskningsloggen');
      } else {
        toast.error('Kunde inte ladda granskningslogg');
      }
    } finally {
      setLoading(false);
    }
  };

  const getActionIcon = (action) => {
    const icons = {
      'create': 'fa-plus-circle',
      'view': 'fa-eye',
      'edit': 'fa-edit',
      'sign': 'fa-signature',
      'amend': 'fa-history',
      'export_pdf': 'fa-file-pdf',
      'transfer': 'fa-exchange-alt',
      'upload_attachment': 'fa-paperclip',
      'delete_attachment': 'fa-trash'
    };
    return icons[action] || 'fa-circle';
  };

  const getActionColor = (action) => {
    const colors = {
      'create': '#198754',
      'view': '#6c757d',
      'edit': '#0d6efd',
      'sign': '#6f42c1',
      'amend': '#fd7e14',
      'export_pdf': '#dc3545',
      'transfer': '#20c997',
      'upload_attachment': '#0dcaf0',
      'delete_attachment': '#dc3545'
    };
    return colors[action] || '#6c757d';
  };

  return (
    <div className="audit-log-modal-overlay" onClick={onClose}>
      <div className="audit-log-modal" onClick={(e) => e.stopPropagation()}>
        <div className="audit-log-header">
          <h2>
            <i className="fas fa-clipboard-list"></i>
            Granskningslogg
          </h2>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        {patientName && (
          <div className="audit-log-patient">
            <i className="fas fa-user"></i>
            {patientName}
          </div>
        )}

        <div className="audit-log-content">
          {loading ? (
            <div className="audit-log-loading">
              <i className="fas fa-spinner fa-spin"></i>
              Laddar granskningslogg...
            </div>
          ) : auditLog.length === 0 ? (
            <div className="audit-log-empty">
              <i className="fas fa-info-circle"></i>
              Ingen aktivitet registrerad.
            </div>
          ) : (
            <div className="audit-log-timeline">
              {auditLog.map((log) => (
                <div key={log.log_id} className="audit-log-item">
                  <div
                    className="audit-log-icon"
                    style={{ backgroundColor: getActionColor(log.action) }}
                  >
                    <i className={`fas ${getActionIcon(log.action)}`}></i>
                  </div>
                  <div className="audit-log-details">
                    <div className="audit-log-action">
                      {log.action_label}
                    </div>
                    <div className="audit-log-meta">
                      <span className="audit-log-user">
                        <i className="fas fa-user"></i>
                        {log.user_name}
                      </span>
                      <span className="audit-log-time">
                        <i className="fas fa-clock"></i>
                        {new Date(log.timestamp).toLocaleString('sv-SE')}
                      </span>
                    </div>
                    {log.ip_address && (
                      <div className="audit-log-ip">
                        <i className="fas fa-network-wired"></i>
                        {log.ip_address}
                      </div>
                    )}
                    {log.details && Object.keys(log.details).length > 0 && (
                      <div className="audit-log-extra">
                        {Object.entries(log.details).map(([key, value]) => (
                          <span key={key} className="audit-detail">
                            {key}: {String(value)}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="audit-log-footer">
          <small>
            <i className="fas fa-info-circle"></i>
            Granskningsloggen sparas i 10 år enligt lagkrav.
          </small>
        </div>
      </div>
    </div>
  );
};

export default AuditLogModal;
